"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  box-sizing: border-box;\n  font-family: ", ";\n  display: ", ";\n  text-indent: ", ";\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px ", " inset !important;\n    -webkit-text-fill-color: ", " !important;\n  }\n\n  ", "\n\n  ", "\n\n  &:focus {\n    ", "\n  }\n\n  &::placeholder {\n    ", "\n    color: ", ";\n    font-family: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _formatters = require("../formatters");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var textInputStyle = (0, _styledSystem.variant)({
  key: 'textInputs'
});

var StyledTextInput = _styledComponents.default.input.attrs({
  type: 'text'
})(_templateObject(), _styledSystem.borderRadius, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.boxShadow, _styledSystem.color, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.height, _styledSystem.lineHeight, _styledSystem.space, _styledSystem.textAlign, textInputStyle, _styledSystem.width, function (props) {
  return props.theme[props.fontFamily] || 'Helvetica, Arial, sans-serif';
}, function (props) {
  return props.display || 'inline';
}, function (props) {
  return props.textIndent || '0';
}, function (props) {
  return props.autocompleteBackground || props.theme.colors.backgroundGray;
}, function (props) {
  return props.theme.colors.medGray;
}, function (props) {
  return props.error && "\n    border: 1px solid " + (props.theme.colors.wagRed || 'red') + ";\n  ";
}, function (props) {
  return props.isFocused && "\n    " + (!props.noBorderOnFocus ? "border: 2px solid " + (props.theme.colors.wagGray || '#aaaaaa') + ";" : 'border: none;') + "\n    background-color: " + (props.theme.colors.white || '#ffffff') + ";\n  ";
}, function (props) {
  return props.isFocused && "\n      outline: none;\n    ";
}, _styledSystem.fontSize, function (props) {
  return props.placeholderColor || props.theme.colors.wagGray;
}, function (props) {
  return props.theme[props.fontFamily] || 'Helvetica, Arial, sans-serif';
});

var TextInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextInput, _React$Component);

  function TextInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", undefined);

    _defineProperty(_assertThisInitialized(_this), "selection", {
      start: false,
      end: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      var onRef = _this.props.onRef;

      if (onRef) {
        onRef(ref);
      }

      _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var onBlur = _this.props.onBlur;

      if (onBlur) {
        onBlur(e);
      }

      _this.setState({
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(e);
      }

      _this.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          type = _this$props.type;
      var input = _this.inputRef;
      _this.selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };

      if (onChange) {
        var value = _this.transformValueByType(e.target.value, type);

        if (e.target.value.length !== value.length) {
          var difference = value.length - e.target.value.length;
          _this.selection = {
            start: input.selectionStart + difference,
            end: input.selectionEnd + difference
          };
        }

        e.target.value = value;
        onChange(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "transformValueByType", function (value, type) {
      if (!type) {
        return value;
      }

      switch (type.toLowerCase()) {
        case 'tel':
        case 'phone':
          return (0, _formatters.formatPhoneNumber)(value);

        case 'zip':
        case 'zipcode':
        case 'zipCode':
          return (0, _formatters.formatZipCode)(value);

        case 'name':
          return (0, _formatters.formatName)(value);

        case 'state':
          return (0, _formatters.formatState)(value);

        case 'lockboxcode':
          return (0, _formatters.formatLockboxCode)(value);

        case 'password':
          return (0, _formatters.formatPassword)(value);

        case 'wag-date':
          return (0, _formatters.formatDate)(value);

        default:
          return value;
      }
    });

    return _this;
  }

  var _proto = TextInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$inputRef = this.inputRef,
        selectionStart = _this$inputRef.selectionStart,
        selectionEnd = _this$inputRef.selectionEnd;
    var update = this.selection.start !== false && this.selection.start !== selectionStart || this.selection.end !== false && this.selection.end !== selectionEnd;

    if (update) {
      this.inputRef.selectionStart = this.selection.start;
      this.inputRef.selectionEnd = this.selection.end;
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        value = _this$props2.value,
        inputVariant = _this$props2.variant,
        touched = _this$props2.touched,
        onRef = _this$props2.onRef,
        validFieldIconName = _this$props2.validFieldIconName,
        textInputVariant = _this$props2.textInputVariant,
        props = _objectWithoutPropertiesLoose(_this$props2, ["value", "variant", "touched", "onRef", "validFieldIconName", "textInputVariant"]);

    var isFocused = this.state.isFocused;
    return React.createElement(StyledTextInput, _extends({
      height: 50,
      width: 1,
      fontSize: 4,
      fontFamily: "body",
      boxShadow: "none",
      color: "medGray"
    }, props, {
      variant: inputVariant,
      isFocused: isFocused,
      ref: this.handleRef,
      value: value,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      onBlur: this.handleBlur
    }));
  };

  return TextInput;
}(React.Component);

_defineProperty(TextInput, "defaultProps", {
  variant: 'default'
});

var _default = TextInput;
exports.default = _default;